import React, { useState, useEffect, useContext } from 'react';
import PropTypes from 'prop-types';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import CssBaseline from '@material-ui/core/CssBaseline';
import useScrollTrigger from '@material-ui/core/useScrollTrigger';
import { Grid, makeStyles, Typography, Box } from '@material-ui/core';
import { Link } from 'react-router-dom';
import PopOver from './Modal/Modal';
import KenSnackbar from '../components/KenSnackbar';
import { useHistory } from 'react-router-dom';
import configContext from '../utils/config';
import Avtar from '../components/KenAvtar';
import ListAltIcon from '@material-ui/icons/ListAlt';
import DashboardIcon from '@material-ui/icons/Dashboard';
import PowerSettingsNewIcon from '@material-ui/icons/PowerSettingsNew';
import LeftMenu from '../../src/assets/icons/LeftMenu.svg';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import { withStyles } from '@material-ui/core/styles';
import ListItemText from '@material-ui/core/ListItemText';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import { Hidden } from '@material-ui/core';
import { getContactByPhone } from '../utils/ApiService';
import { GLOBAL } from '../utils/constants';
import { useTranslation } from 'react-i18next';
import { routes } from '../utils/urls';
import { LightenDarkenColor } from '../utils/componentHelper';
import { useTheme } from 'styled-components';

//for Accordion

import Accordion from '@material-ui/core/Accordion';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';

const StyledMenu = withStyles({
  paper: {
    border: '1px solid #d3d4d5',
    width: 200,
  },
})((props) => (
  <Menu
    elevation={0}
    getContentAnchorEl={null}
    anchorOrigin={{
      vertical: 'bottom',
      horizontal: 'center',
    }}
    transformOrigin={{
      vertical: 'top',
      horizontal: 'center',
    }}
    {...props}
  />
));
const StyledMenuItem = withStyles((theme) => ({
  selected: {
    backgroundColor: `${theme.palette.KenColors.primary} !important`,
    color: `${theme.palette.common.white} !important`,
    '& .MuiListItemIcon-root, & .MuiListItemText-primary': {
      color: theme.palette.common.white,
    },
  },
}))(MenuItem);

const useStyles = makeStyles((theme) => {
  const { config } = React.useContext(configContext);
  return {
    root: {
      backgroundColor: theme.palette.KenColors.white,
      paddingTop: 12,
      paddingBottom: 12,
    },
    heading: {
      fontWeight: '600',
      fontSize: '24px',
      color: theme.palette.KenColors.neutral900,
      alignItems: 'center',
      textAlign: 'center',
      [theme.breakpoints.down('xs')]: {
        fontSize: 12,
        maxWidth: 100,
      },
    },

    nameIntials: {
      paddingTop: 5,
      height: '30px',
      width: '30px',
      fontSize: '12px',
      color: theme.palette.KenColors.primary,
      backgroundColor:
        config?.customization?.palette?.activeStepBgColor ||
        `${LightenDarkenColor(
          theme.palette.KenColors.primary,
          GLOBAL.COLORS.SIDENAV.STEP_COLOR.RANGE
        )}`,
      borderRadius: '50%',
    },
    logo: {
      height: 64,
      [theme.breakpoints.down('xs')]: {
        height: 45,
        width: 110,
      },
    },
    burgerMeu: {
      paddingRight: 12,
    },
    logoImg: {
      [theme.breakpoints.only('xs')]: {
        width: '120px',
      },
    },
    logoContent: {
      display: 'flex',
      justifyContent: 'start',
      alignContent: 'center',
      maxWidth: 'fit-content',
    },

    linkLogo: {
      display: 'flex',
      alignItem: 'center',
      padding: '16px 8px 16px 8px',
    },
    logOutLogo: {
      padding: '8px',
      '&:hover': {
        cursor: 'pointer',
      },
    },
    details: {
      display: 'inline-flex',
    },
  };
});
function ElevationScroll(props) {
  const { children, window } = props;
  const trigger = useScrollTrigger({
    disableHysteresis: true,
    threshold: 0,
    target: window ? window() : undefined,
  });

  return React.cloneElement(children, {
    elevation: trigger ? 4 : 0,
  });
}

ElevationScroll.propTypes = {
  children: PropTypes.element.isRequired,
  window: PropTypes.func,
};

export default function Header(props) {
  const { t } = useTranslation();
  const [firstName, setFirstName] = useState();
  const [lastName, setLastName] = useState();
  const { config } = useContext(configContext);
  let phone;
  phone = localStorage.getItem('userPhone')

  //check the later its giving error

  useEffect(() => {
    if (phone) {
      // getContactByPhone(phone).then((res) => {
      //   setFirstName(res.data[0].FirstName);
      //   setLastName(res.data[0].LastName);
      // });
      getContactByPhone(phone).then((res) => {
        setFirstName("test");
        setLastName("test");
      }).catch(err =>{
        setFirstName("Test");
        setLastName("User");
      })
    }
  }, [phone]);

  const {
    children,
    title,
    hideNav,
    setHideNav,
    hidden,
    startDate,
    endDate,
    Fees,
    internationalFees,
    internationalCurrencySymbolc,
    currencySymbolc,
  } = props;
  const classes = useStyles();

  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [snackbarSeverity, setSnackbarSeverity] = useState('success');
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const [mobile, setMobile] = useState(phone);
  const history = useHistory();
  const details = props.instituteDetails;

  const [path, setPath] = useState('');
  useEffect(() => {
    const currentPath = history?.location?.pathname;
    setPath(currentPath);
  }, [history]);

  const navigateToPrograms = () => {
    history.push({
      pathname: `${routes.programs}`,
      state: {
        userDetails: {
          First_Name: firstName,
          Last_Name: lastName,
          ...history?.location?.state?.userDetails,
        },
        // ParentId: history?.location?.state?.ParentId,
        // Email: history?.location?.state?.Email,
        ParentId:"1",
        Email: "test@ken42.com",
      },
    });
  };

  const handleSnackbarClose = (event, reason) => {
    if (reason === GLOBAL.REASONS.CLICKAWAY) return;
    setOpenSnackbar(false);
  };

  const handleSnackbarOpen = (severity, message) => {
    setOpenSnackbar(true);
    setSnackbarSeverity(severity);
    setSnackbarMessage(message);
  };

  // for popOver
  const [open, setOpen] = React.useState(false);

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleRetrieve = () => {
    history.push({
      pathname: `${routes.draft}`,
      state: {
        userDetails: {
          phoneNumber: mobile,
        },
      },
    });
  };

  const handlelogOut = () => {
    localStorage.clear();
    history.push(`${routes.root}`);
  };
  //for menu item state and handlers
  const [anchorEl, setAnchorEl] = React.useState(null);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleCloseMenu = () => {
    setAnchorEl(null);
  };

  const theme = useTheme();
  return (
    <React.Fragment>
      <CssBaseline />
      <ElevationScroll {...props}>
        <AppBar classes={{ root: classes.root }}>
          <Toolbar style={{ backgroundColor: theme.palette.KenColors.white }}>
            <Grid
              container
              direction='row'
              alignItems='center'
              justify='space-between'
              xs={12}
              sm={12}
              md={12}
            >
              <Grid item xs={4} md={3} className={classes.logoContent}>
                <Box
                  display='flex'
                  justifyContent='center'
                  alignContent='center'
                >
                  {hidden && (
                    <Hidden smUp={true}>
                      <img
                        src={LeftMenu}
                        className={classes.burgerMeu}
                        onClick={() => {
                          setHideNav(!hideNav);
                        }}
                      ></img>
                    </Hidden>
                  )}
                  {config && (
                    // <Link to={`${routes.programs}`}>
                      <img
                        height="64px"
                        className={classes.logoImg}
                        src={props.logo || config.logo}
                        alt="i"
                      ></img>
                    // </Link>
                  )}
                </Box>
              </Grid>
              <Grid item md={5} xs={4}>
                {title ? (
                  <Typography className={classes.heading}>{title}</Typography>
                ) : null}
                {children}
              </Grid>
              {props.isLogo === false ? (
                mobile && (
                  <Grid item>
                    <Box onClick={handleClick} style={{display:"flex",justifyContent:"space-around",alignItems:"center"}}>
                      {
                        firstName && (
                          <Box>
                            <Typography color="primary">
                              Hi,{firstName ||  props.firstName}
                            </Typography>
                          </Box>
                        )
                      }
                      {firstName && (
                        <Avtar
                          firstName={firstName || props.firstName}
                          lastName={lastName || props.lastName}
                        />
                      )}
                    </Box>
                    <StyledMenu
                      id='customized-menu'
                      anchorEl={anchorEl}
                      keepMounted
                      open={Boolean(anchorEl)}
                      onClose={handleCloseMenu}
                      autoFocus={false}
                      MenuListProps={{ disablePadding: true }}
                    >
                      <StyledMenuItem
                        onClick={handleRetrieve}
                        selected={path === `${routes.draft}` ? true : false}
                      >
                        <Box
                          display="flex"
                          justifyContent="center"
                          alignItems="center"
                        >
                          <ListItemIcon>
                            <DashboardIcon></DashboardIcon>
                          </ListItemIcon>

                          <ListItemText
                            primary={t('labels:header_menus_dashboard')}
                          />
                        </Box>
                      </StyledMenuItem>

                      {/* <StyledMenuItem
                        selected={path === `${routes.programs}` ? true : false}
                        onClick={navigateToPrograms}
                      >
                        <Box
                          display="flex"
                          justifyContent="center"
                          alignItems="center"
                        >
                          <ListItemIcon>
                            <ListAltIcon></ListAltIcon>
                          </ListItemIcon>

                          <ListItemText
                            primary={t('labels:header_menus_applications')}
                          />
                        </Box>
                      </StyledMenuItem> */}

                      <StyledMenuItem onClick={handlelogOut}>
                        <Box
                          display="flex"
                          justifyContent="center"
                          alignItems="center"
                        >
                          <ListItemIcon>
                            <PowerSettingsNewIcon></PowerSettingsNewIcon>
                          </ListItemIcon>
                          <ListItemText
                            primary={t('labels:header_menus_signOut')}
                          />
                        </Box>
                      </StyledMenuItem>
                    </StyledMenu>
                  </Grid>
                )
              ) : (
                <Grid md={6} xs={6} className={classes.details}>
                  <Typography className={classes.detailContent}>
                    {details && details.email}
                  </Typography>
                  <Typography className={classes.detailContent}>
                    {details && details.phone}
                  </Typography>
                  <Typography className={classes.detailContent}>
                    {details && details.supportLine1}
                  </Typography>
                  <Typography className={classes.detailContent}>
                    {details && details.supportLine2}
                  </Typography>
                  <Typography className={classes.detailContent}>
                    {details && details.link}
                  </Typography>
                </Grid>
                // ""
              )}
            </Grid>
            <PopOver
              handleOpen={handleOpen}
              handleClose={handleClose}
              open={open}
              retrieve={true}
              handleSnackbarOpen={handleSnackbarOpen}
            />
          </Toolbar>
          {startDate ? (
            <>
              <Grid className={classes.accordionWrap}>
                <Accordion
                  smDown
                  mdDown
                  lgDown
                  className={classes.accordionContnet}
                >
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel1a-content"
                    id="panel1a-header"
                  >
                    <Typography className={classes.accordionHeading}>
                      Details
                    </Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                    <Grid item md={12} xs={12} className={classes.feePay}>
                      <p className={classes.feeLabel}>
                        Start Date : {startDate}
                      </p>
                      <p className={classes.feeLabel}>End Date : {endDate}</p>
                      <p className={classes.feeLabel}>
                        Fee (INDIAN) : {currencySymbolc}
                        {Fees}
                      </p>
                      <p className={classes.feeLabel}>
                        Fee (INTERNATIONAL) : {internationalCurrencySymbolc}
                        {internationalFees}
                      </p>
                    </Grid>
                  </AccordionDetails>
                </Accordion>
              </Grid>
              {/* <Hidden xsDown>
                <Grid item md={12} xs={12} className={classes.feePay}>
                  <p className={classes.feeLabel}>Start Date : {startDate}</p>
                  <p className={classes.feeLabel}>End Date : {endDate}</p>
                  <p className={classes.feeLabel}>Fee (INDIAN) : {Fees}</p>
                  <p className={classes.feeLabel}>
                    Fee (INTERNATIONAL) : {internationalFees}
                  </p>
                </Grid>
              </Hidden> */}
            </>
          ) : null}
        </AppBar>
      </ElevationScroll>
      <Toolbar />

      <KenSnackbar
        message={snackbarMessage}
        severity={snackbarSeverity}
        autoHideDuration={2000}
        open={openSnackbar}
        handleSnackbarClose={handleSnackbarClose}
        position='Bottom-Right'
      />
    </React.Fragment>
  );
}